import React from 'react';
import { VerificationReviewFinePrint, VerificationFinePrint } from 'Components/FinePrint';
import './SheerIdFinePrint.css';

export const SheerIdFinePrint = ({ isReview = false }) => (
  <div className="sheerIdFinePrintWrapper">
    {isReview ? <VerificationReviewFinePrint /> : <VerificationFinePrint />}
  </div>
);
